import styled from 'styled-components'

type Props = {
	hasModal: boolean
}

export const Wrapper = styled.div<Props>`
	position: fixed;
	inset: 0;
	pointer-events: ${({ hasModal }) => (hasModal ? 'auto' : 'none')};
	z-index: 10;
`
